import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'encodeBase64' })
export class EncodeBase64Pipe implements PipeTransform {
  constructor() {}
  transform(value: string): string {
    return encodeURIComponent(unescape(window.btoa(value)));
  }
}
